import { render } from "./FormInputPhoneField.vue?vue&type=template&id=f6e32d64"
import script from "./FormInputPhoneField.vue?vue&type=script&lang=js"
export * from "./FormInputPhoneField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__